module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_keywords_via_file":"Add / Edit keywords per file"},"fr":{"add_keywords_via_file":"Ajout / Édition de mots clés via un fichier Excel"},"de":{"add_keywords_via_file":"Hinzufügen / Bearbeiten von Schlüsselwörtern über eine Excel-Datei"}}')
  delete Component.options._Ctor
}
